import Container from './Container'
import { Alignment, Heading, HeadingSize, ReviewStars } from '@big-red-group/storefront-common-ui'
import Icon, { IconName } from './Icons'
import { Wrapper, TrustFactors, Point, IconWrap, StarWrapper, Flex } from './TrustFactorBar.styles'
import React from 'react'

type TrustFactor = {
  heading: string
  subheading: React.ReactNode
  icon: IconName
}

type TrustFactorBarProps = {
  title?: string
  titleSize?: HeadingSize
  titleAlignment?: Alignment
  oneColumn?: boolean
  smallDesktopColumns?: boolean
}

const TrustFactorBar: React.FC<TrustFactorBarProps> = ({
  title,
  titleSize = 'M',
  titleAlignment = 'center',
  oneColumn = false,
  smallDesktopColumns = false,
}) => {
  const trustFactors: TrustFactor[] = [
    {
      heading: 'Unbeatable Value',
      subheading: <>With a price guarantee</>,
      icon: 'cash',
    },
    {
      heading: 'Trusted by thousands',
      subheading: (
        <Flex>
          <StarWrapper>
            <ReviewStars rating={4.5} />
          </StarWrapper>
          4.5/5 Feefo rating
        </Flex>
      ),
      icon: 'trophy',
    },
    {
      heading: 'Supported by locals',
      subheading: <>Aussie owned & operated</>,
      icon: 'koala2',
    },
    {
      heading: 'Here to help',
      subheading: <>363 days of support</>,
      icon: 'heartHands',
    },
  ]

  return (
    <Wrapper $oneColumn={oneColumn} smallDesktopColumns={smallDesktopColumns}>
      <Container noSpacingTop noSpacingBottom>
        {title && (
          <Heading size={titleSize} alignment={titleAlignment} as="p" dataTestId="trustfactorbar-title">
            {title}
          </Heading>
        )}
        <TrustFactors $oneColumn={oneColumn} smallDesktopColumns={smallDesktopColumns}>
          {trustFactors.map(({ heading, subheading, icon }) => (
            <Point key={heading} data-testid="trustfactor" smallDesktopColumns={smallDesktopColumns}>
              <IconWrap>
                <Icon name={icon} />
              </IconWrap>
              <div>
                <span>{heading}</span>
                <small data-testid="trustfactor-subheading">{subheading}</small>
              </div>
            </Point>
          ))}
        </TrustFactors>
      </Container>
    </Wrapper>
  )
}

export default TrustFactorBar
